export default {
  install: (Vue, options) => {
    const LOGOUT = "user/logout";

    Vue.prototype.$helpers = {
      login() {
        options.$router.push("/login");
      },
      logout() {
        options.$store
          .dispatch(LOGOUT)
          .then(() => options.$router.push("/"))
          .catch(err => console.log(err));
      },
      handleFeedback(e) {
        let result = false;
        switch (e) {
          case "invalidToken":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
          case "NoUserAccessRight":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/denied"))
              .catch(err => console.log(err));
            break;
          case "userIdRequired":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
        }

        return result;
      },
      alert(title, message, variant) {
        return options.$swal(title, message, variant);
      },
      showDialog(title, message, variant) {
        options.$swal(title, message, variant);
        // options.$snotify.create({
        //   title: caption,
        //   body: message,
        //   config: {
        //     type: variant,
        //     position: "rightTop"
        //   }
        // });
      },
      showToast(caption, message, variant) {
        options.$swal(title, message, variant);
        // options.$snotify.create({
        //   title: caption,
        //   body: message,
        //   config: {
        //     type: variant,
        //     position: "rightTop"
        //   }
        // });
      }
    };
  }
};
